export default __webpack_public_path__ + "static/media/meterkast_preview.c7d1df18.jpg";